import productContainerTemplate from 'core-rr.j2';
import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { defaultQuickshopOptions } from '../utils/defaultQuickshopOptions';
import { productQuickshopOptions } from '@product/js/utils/productQuickshopOptions';
import { setProductTileSwatchImage, setProductTileSwatchUrl } from '../../../product/js/utils/tileUtils';

import { dDom } from '../utils/renderUtils';

import { init as dyInit } from '../../../core/js/components/dynamicYieldRecommendationComponent';
import {
    richRelevanceSwiperInit
} from '../../../product/js/utils/swiperInits';

import { attachQuickshopLaunchEvent } from '../../../product/js/utils/tileUtils';
import { getRRProductRecords } from '../utils/rrUtils';
import { getSlidesPerView } from '../../../core/js/utils/rrUtils';
import { favoriteClicked } from '../../../core/js/utils/favoritesUtils';

export function onStateChange(store, watchValue, oldVal, newVal) {
    const state = store.getState();
    const placementId = this.rrPlacement;
    const slidesPerView = getSlidesPerView(state, placementId);

    const dictionary = {
        core: state.core,
        isSwiper: this.isSwiper,
        slidesPerView: slidesPerView ? slidesPerView : 6,
        isRightRail: this.isRightRail,
        placementId: placementId
    };

    this.render(store, this, dictionary);
}

export function attachEvents(store) {
    const placementId = this.rrPlacement;
    const quickshopOptions = setComponentQuickshopOptions(placementId, store);

    attachQuickshopLaunchEvent(
        store,
        this,
        () => getRRProductRecords(store.getState(), placementId),
        quickshopOptions
    );

    $(document).on('click', this.scopedSelector('.js-favorite-toggle'), (e) => {
        return favoriteClicked(store, e);
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-swatch-link-category'), (e) => {
        e.preventDefault();

        setProductTileSwatchImage(store, e);
        setProductTileSwatchUrl(e);
    });

    /**
     * Rich Relevance Click Tracking
     */

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('a[data-rr-click-tracking]'), (e) => {
        $.ajax($(e.currentTarget).data('rr-click-tracking'));
    });
}

function afterRender(store) {
    const hasData = !_.isEmpty($(this.scopedSelector('.js-rr-container')).data());
    const slidesPerView = hasData ? $(this.scopedSelector('.js-rr-container')).data().slidesPerView : 6;
    richRelevanceSwiperInit(this, slidesPerView);
    this.removeWatchers();
    if (_.get(window, 'DYO')) {
        const targetElement = this.rrPlacement ? `.js-rr-grid.js-rr-placement-${this.rrPlacement}` : '.js-rr-grid';
        DYO.recommendations.registerElements(targetElement);
    }
}

function afterRebind(store) {
    this.onStateChange(store);
}

export function determineRRPlacement(store) {
    // richRelevanceComponent doesn't always have rrPlacement available at init (see productComponent.js)
    // "this" is dynamicYieldRecommendationComponent
    // "this.parent" is richRelevanceComponent

    const rrPlacement = this.parent.rrPlacement;
    const templateLocation = `.js-dy-recommendations .js-rr-placement-${rrPlacement}`;

    this.templateLocation = templateLocation;
    this.rrPlacement = rrPlacement;
}

function setComponentQuickshopOptions(placementId, store) {
    const state = store.getState();
    const primaryPlacementId = _.get(
        state,
        'core.constants.thirdParty.default.dynamic_yield.placement_ids.productPrimary'
    );
    const productAlsoBoughtWithId = _.get(
        state,
        'core.constants.thirdParty.default.dynamic_yield.placement_ids.productAlsoBoughtWith'
    );
    const visuallySimilarId = _.get(
        state,
        'core.constants.thirdParty.default.dynamic_yield.placement_ids.productVisuallySimilar'
    );
    const productPlacementIds = [
        primaryPlacementId,
        productAlsoBoughtWithId,
        visuallySimilarId
    ];

    return productPlacementIds.includes(placementId) ? productQuickshopOptions : defaultQuickshopOptions;
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-rr-container',
        watch: ['core.rrRecs', 'core.deviceCharacteristics'],
        name: 'richRelevanceComponent',
        children: [
            [dyInit, {
                beforeConstruction: determineRRPlacement
            }]
        ],
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        afterRender: afterRender,
        renderType: dDom,
        template: productContainerTemplate,
        isSwiper: true,
        isRightRail: false,
        afterRebind: afterRebind
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
